import React, { useState } from "react";
import Modal from "react-modal";
import "../pages/ContentFrame.css";

const CertificationCard = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    Modal.setAppElement(document.getElementById("root"));
    return (
        <>
            <div className="certification_card" onClick={() => setIsModalOpen(true)}>
                <img className="certification_img" src={props.image} />
                <div className="certification_title">{props.title}</div>
            </div>
            <Modal
                isOpen={isModalOpen}
                style={{
                    content: {
                        width: "500px",
                        height: "650px",
                        margin: "auto",
                        marginTop: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
                onRequestClose={() => {
                    setIsModalOpen(false);
                }}
            >
                <img style={{ width: "90%" }} src={props.image} />
            </Modal>
        </>
    );
};

export default CertificationCard;
